import Axios from 'axios'
import { waitForLanguage } from '../../shared'

const axios = Axios.create({})

axios.interceptors.request.use(async (config) => {
	config.headers['Accept-Language'] = await waitForLanguage()
	return config
})

axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.post['Access-Control-Allow-Headers'] =
	'Origin, X-Requested-With, Content-Type, Accept'

export default axios
